import View from "./view.js";
import OrbitViewport from "../viewports/orbit-viewport.js";
import OrbitController from "../controllers/orbit-controller.js";
class OrbitView extends View {
    constructor(props = {}) {
        super(props);
        this.props.orbitAxis = props.orbitAxis || 'Z';
    }
    get ViewportType() {
        return OrbitViewport;
    }
    get ControllerType() {
        return OrbitController;
    }
}
OrbitView.displayName = 'OrbitView';
export default OrbitView;
